import React from 'react';
import PropTypes from 'prop-types';
import { StepperContext } from './StepperContext';

export const Stepper = ({ activeStep, children, classes = {}, components = {}, ...rest }) => {
  // assign default components
  const StepperComp = components.StepperComp ?? 'div';

  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const steps = childrenArray.map((step, index) =>
    // @ts-ignore
    React.cloneElement(step, {
      activeStep,
      stepIndex: index,
      // @ts-ignore
      ...step.props,
      className: classes.stepperChildren
    })
  );

  return (
    <StepperContext.Provider
      value={{
        activeStep
      }}
    >
      <StepperComp className={classes.stepper} data-nr-component='stepper' activeStep={activeStep} {...rest}>
        {steps}
      </StepperComp>
    </StepperContext.Provider>
  );
};

Stepper.defaultProps = {
  classes: {},
  components: {}
};

Stepper.propTypes = {
  /**
   * Set the active step (zero based index).
   */
  activeStep: PropTypes.number.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  /** Child elements.  */
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.func)
  ]).isRequired,
  classes: PropTypes.object,
  /** Optional overrides to default HTML elements used */
  // @ts-expect-error
  components: PropTypes.shape({
    /** Styled or non styled component */
    StepperComp: PropTypes.elementType
  })
};
